import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'

// The seasons. No search params: a season a year, and the whole list fits one screen.
// Reached from `/leagues`, which owns the menu entry.

export const seasonsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/leagues/seasons',
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/seasons.tsx')),
})

export const seasonsLink = { to: '/leagues/seasons' } as const
